/* src/views/argent/ArgentChrome.jsx — LE CHROME DE LA DESTINATION € ARGENT
   (lot 5, décision Dimitri 2026-08-28 : « lot de rangement, pas de refonte »).

   Balisage FIDÈLE au bandeau + à la bascule de docs/handoff/argent-complet.jsx
   (lignes 54-111) — valeurs en props, gestes en onXxx, RIEN d'autre. Les cinq
   écrans existants se rendent DESSOUS, tels quels (le contenu ne vit pas ici).

   La bascule garde les cinq entrées du proto — « Statistiques » ouvre l'écran
   refondu à deux modèles (lot Statistiques 2026-09 : conciergerie commission /
   sous-location marge — AdminStatsView, monté par App). */
import React from 'react'
import { montantIncalculable, TITRE_MONTANT_INCALCULABLE } from '../../lib/format'
// F13 : une valeur inconnue (lecture ratée) s'affiche « — », jamais 0.
import { fmtPourcent, fmtCompte } from '../../lib/argent-lecture'

// title « montant incalculable — donnée manquante » sur un chiffre « — »
// (paquet argent 2026-09-03) ; undefined (pas d'attribut) sur un vrai montant.
const titreMontant = (v) => (montantIncalculable(v) ? TITRE_MONTANT_INCALCULABLE : undefined)

const SOUS_ONGLETS = [
  { id: 'donnees', tab: 'donnees', ic: '◫', label: 'Données' },
  { id: 'facturation', tab: 'facturation', ic: '€', label: 'Facturation' },
  { id: 'documents', tab: 'historique', ic: '▤', label: 'Historique' },
  { id: 'compta', tab: 'compta', ic: '◔', label: 'Compta' },
  { id: 'stats', tab: 'stats-admin', ic: '◑', label: 'Statistiques' },
]

export default function ArgentChrome({
  monthLabel,
  nbProprios,
  totalFacture,
  commissions,
  sousLoc,
  charges,
  resultatNet,
  margePartielle,
  menageCollecte,
  occupation,
  incidents,
  commissionsManquantes = [],
  fmtE,
  tabActif,
  onSousOnglet,
  onMoisPrec,
  onMoisSuiv,
}) {
  return (
    <>
      <div className="bandeau" style={{minHeight:'0'}}>
        <div style={{position:'relative',display:'flex',alignItems:'flex-start',gap:'16px',flexWrap:'wrap'}}>
          <div style={{flex:'1',minWidth:'150px'}}>
            <p className="bSous" style={{margin:'0'}}>Total à facturer · {monthLabel}</p>
            <p data-testid="argent-bandeau-total" title={titreMontant(totalFacture)} style={{fontSize:'32px',fontWeight:'600',color:'#fff',lineHeight:'1.1',margin:'3px 0 0'}}>{fmtE(totalFacture)}</p>
            <p style={{fontSize:'11px',color:'rgba(255,255,255,.7)',margin:'2px 0 0'}}>ce qui sera facturé aux {nbProprios} propriétaires</p>
          </div>
          <div style={{flex:'0 0 auto',minWidth:'170px',background:'rgba(255,255,255,.13)',borderRadius:'11px',padding:'9px 12px'}}>
            <div style={{display:'flex',justifyContent:'space-between',gap:'14px',padding:'4px 0'}}>
              <span style={{fontSize:'11px',color:'rgba(255,255,255,.72)'}}>Commissions</span>
              <b title={titreMontant(commissions)} style={{fontSize:'11.5px',color:'#fff',fontWeight:'500'}}>{fmtE(commissions)}</b>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',gap:'14px',padding:'4px 0',borderTop:'1px solid rgba(255,255,255,.15)'}}>
              <span style={{fontSize:'11px',color:'rgba(255,255,255,.72)'}}>Sous-location</span>
              <b style={{fontSize:'11.5px',color:'#fff',fontWeight:'500'}}>{fmtE(sousLoc)}</b>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',gap:'14px',padding:'4px 0',borderTop:'1px solid rgba(255,255,255,.15)'}}>
              <span style={{fontSize:'11px',color:'rgba(255,255,255,.72)'}}>Charges</span>
              <b style={{fontSize:'11.5px',color:'#fff',fontWeight:'500'}}>− {fmtE(charges)}</b>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',gap:'14px',padding:'6px 0 0',marginTop:'4px',borderTop:'1.5px solid rgba(255,255,255,.4)'}}>
              <span style={{fontSize:'11px',fontWeight:'600',color:'#fff'}}>Résultat net</span>
              <b title={titreMontant(resultatNet)} style={{fontSize:'13px',color:'#fff'}}>{fmtE(resultatNet)}</b>
            </div>
            {margePartielle && (
              <div data-testid="marge-partielle-hint" style={{fontSize:'9.5px',color:'rgba(255,255,255,.6)',marginTop:'5px',fontStyle:'italic',lineHeight:'1.35'}}>
                Chiffres partiels — les revenus du mois ne sont pas encore tous entrés.
              </div>
            )}
          </div>
        </div>
        {/* La commission muette (paquet argent 2026-09-03) : un taux manquant
            n'ampute plus le total en silence — il est nommé ici, et le total
            au-dessus s'affiche « — » (incomplet), jamais un chiffre amputé. */}
        {commissionsManquantes.length > 0 && (
          <div data-testid="argent-comm-manquante" style={{marginTop:'10px',background:'rgba(255,255,255,.13)',border:'1px solid rgba(255,183,77,.55)',borderRadius:'9px',padding:'7px 11px',fontSize:'11px',lineHeight:'1.45',color:'#ffe2b3'}}>
            <b style={{color:'#ffcf8a'}}>⚠ Total incomplet</b>
            {commissionsManquantes.map((nom) => (
              <div key={nom}>commission non calculée sur {nom} : taux manquant</div>
            ))}
          </div>
        )}
        <div style={{display:'flex',gap:'8px',marginTop:'12px',paddingTop:'11px',borderTop:'1px solid rgba(255,255,255,.18)',position:'relative'}}>
          <span style={{flex:'1',minWidth:'0',background:'rgba(255,255,255,.13)',borderRadius:'11px',padding:'8px 10px'}}>
            <b style={{display:'block',fontSize:'17px',color:'#fff',fontWeight:'600',lineHeight:'1.1'}}>{fmtE(menageCollecte)}</b>
            <span style={{display:'block',fontSize:'9.5px',color:'rgba(255,255,255,.72)',marginTop:'2px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>Ménage collecté</span>
          </span>
          <span style={{flex:'1',minWidth:'0',background:'rgba(255,255,255,.13)',borderRadius:'11px',padding:'8px 10px'}}>
            <b style={{display:'block',fontSize:'17px',color:'#fff',fontWeight:'600',lineHeight:'1.1'}}>{fmtPourcent(occupation)}</b>
            <span style={{display:'block',fontSize:'9.5px',color:'rgba(255,255,255,.72)',marginTop:'2px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>Occupation</span>
          </span>
          <span style={{flex:'1',minWidth:'0',background:'rgba(255,255,255,.13)',borderRadius:'11px',padding:'8px 10px'}}>
            <b style={{display:'block',fontSize:'17px',color:'#fff',fontWeight:'600',lineHeight:'1.1'}}>{fmtCompte(incidents)}</b>
            <span style={{display:'block',fontSize:'9.5px',color:'rgba(255,255,255,.72)',marginTop:'2px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>Incidents</span>
          </span>
        </div>
        <div className="mois">
          <button onClick={onMoisPrec} aria-label="Mois précédent">‹</button>
          <span>{monthLabel}</span>
          <button onClick={onMoisSuiv} aria-label="Mois suivant">›</button>
        </div>
      </div>
      <div className="bascule" data-testid="argent-bascule">
        {SOUS_ONGLETS.map((o) => (
          <button key={o.id} className={tabActif === o.tab ? 'on' : ''} onClick={() => onSousOnglet(o.tab)}>
            <span style={{fontSize:'14px'}}>{o.ic}</span>{o.label}</button>
        ))}
      </div>
    </>
  )
}

/* La phrase de révision (ArgentStatsRevision) est RETIRÉE (lot Statistiques
   2026-09) : l'onglet Statistiques affiche désormais l'écran refondu à deux
   modèles — AdminStatsView, monté par App sous ce chrome. */
